const getTheme = () => {
  const theme = localStorage.getItem("theme");
  if (!theme) {
    localStorage.setItem("theme", "theme-light");
    return "theme-light";
  } else {
    return theme;
  }
};
export default getTheme;
